import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast, Toaster } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DemoCheckout() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [oferta, setOferta] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    document.title = "MontaJá · Demonstração";
    axios.get(`${API}/oferta/${token}`).then(r => setOferta(r.data)).catch(() => toast.error("Pedido não encontrado"));
  }, [token]);

  const confirmar = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/oferta/${token}/pagar-simulado`);
      toast.success("Pagamento confirmado!");
      navigate(r.data.portal);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao confirmar");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F1F5F9] flex flex-col items-center p-5" data-testid="demo-checkout">
      <Toaster richColors />
      <div className="w-full max-w-md mt-8">
        <div className="flex items-center gap-2 justify-center mb-6">
          <div className="w-10 h-10 rounded-xl bg-[#142766] flex items-center justify-center text-white font-black text-lg">M</div>
          <div className="text-2xl font-extrabold text-[#142766]">Monta<span className="text-[#FF6700]">Já</span></div>
        </div>
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
          <div className="text-[10px] font-extrabold uppercase tracking-widest text-[#FF6700] mb-1">Pagamento seguro</div>
          <h1 className="text-lg font-extrabold text-[#142766]">Resumo do pedido</h1>
          {oferta ? (
            <>
              <div className="mt-3 space-y-1.5 text-sm text-slate-700">
                <div className="flex justify-between"><span>Pedido</span><b>{oferta.protocolo}</b></div>
                {(oferta.itens || []).map((i, k) => (
                  <div key={k} className="flex justify-between"><span>{i.quantidade}x {i.produto}</span><span>{i.marca || ""}</span></div>
                ))}
                <div className="border-t border-slate-100 pt-2 flex justify-between text-base">
                  <span className="font-bold">Total da montagem</span>
                  <b className="text-[#142766]">R$ {Number(oferta.valor_montagem_total || 0).toFixed(2).replace(".", ",")}</b>
                </div>
              </div>
              <button onClick={confirmar} disabled={busy}
                className="mt-5 w-full rounded-xl bg-[#00A859] text-white py-3.5 font-extrabold text-sm disabled:opacity-60"
                data-testid="demo-confirmar-pagamento">
                {busy ? "Confirmando…" : "✓ Confirmar Pagamento Simulado"}
              </button>
              <div className="mt-3 text-center text-[11px] text-slate-400">
                🧪 Ambiente de demonstração — nenhuma cobrança real será realizada.
              </div>
            </>
          ) : (
            <div className="py-8 text-center text-sm text-slate-400">Carregando…</div>
          )}
        </div>
      </div>
    </div>
  );
}
